// @ts-check
import Reminders from './Reminders';

export default Reminders;
